import React, { useContext } from 'react';
import { AddBeanBtn } from '../AddBeanBtn';
import {ModelContext} from "../../metadata/ModelSource";

export function AddVehicleBtn(props) {

  let applicationModel = useContext(ModelContext);

  let vehicleCount = 0;

  let risks = applicationModel.getValue(props.path);

  if (risks) {
    for (const risk of risks) {
      if (risk.typeCd === props.proto.typeCd) {
        vehicleCount ++;
      }
    }
  }

  return <AddBeanBtn {...props} labe={vehicleCount > 0 ? 'Add Another Vehicle' : 'Add Vehicle' } />;
}